import type { ErrorInfo, ReactElement, ReactNode } from 'react'
import { Component } from 'react'
import { useTranslations } from 'next-intl'

type Props = { children: ReactElement | ReactElement[] }
type State = { hasError: boolean }

// A class component cannot call a hook, so the fallback that needs the translator is its own component.
const CrashMessage = () => {
    const t = useTranslations('root')

    return (
        <div className="flex box-border items-center justify-center w-full h-full">
            <p>{t('shared.errorBoundary.text.anErrorOccurred')}</p>
        </div>
    )
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error('Crash:', error, info)
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <CrashMessage />
        }

        return this.props.children
    }
}

export default ErrorBoundary
